// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DingtalkCircleFilledSvg from "@ant-design/icons-svg/es/asn/DingtalkCircleFilled";
import AntdIcon from '../components/AntdIcon';

var DingtalkCircleFilled = function DingtalkCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DingtalkCircleFilledSvg
  }));
};

DingtalkCircleFilled.displayName = 'DingtalkCircleFilled';
export default React.forwardRef(DingtalkCircleFilled);